import React from 'react';

// App
export const Avatar = (
  <svg id="icn-avatar" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <rect id="Rectangle_9452" data-name="Rectangle 9452" width="24" height="24" fill="#80fc04" opacity="0" />
    <g id="Group_136" data-name="Group 136" transform="translate(3.5 3.5)">
      <g id="account-circle_1_">
        <path
          id="Path_57"
          data-name="Path 57"
          d="M8.5,0A8.5,8.5,0,1,0,17,8.5,8.527,8.527,0,0,0,8.5,0Zm0,2.55A2.5,2.5,0,0,1,11.05,5.1,2.5,2.5,0,0,1,8.5,7.65,2.5,2.5,0,0,1,5.95,5.1,2.5,2.5,0,0,1,8.5,2.55Zm0,12.07A6.192,6.192,0,0,1,3.4,11.9c0-1.7,3.4-2.633,5.1-2.633s5.1.933,5.1,2.633A6.192,6.192,0,0,1,8.5,14.62Z"
          fill="#acacac"
        />
      </g>
    </g>
  </svg>
);

export const Loading = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.528 52.528">
    <path
      d="M183.764,359.476a22.288,22.288,0,0,1,0,44.576v2.476a24.764,24.764,0,1,0,0-49.528h0A24.764,24.764,0,0,0,159,381.764h2.476a22.313,22.313,0,0,1,22.288-22.288"
      transform="translate(-157.5 -355.5)"
      strokeWidth="3"
    />
  </svg>
);

export const Bell = (
  <svg id="icn-topbar-notifications" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <rect id="Rectangle_9404" data-name="Rectangle 9404" width="32" height="32" fill="#80fc04" opacity="0" />
    <g id="Symbol_2_3" data-name="Symbol 2 – 3" transform="translate(6.5 5)" clipPath="url(#clipPath-bell)">
      <g id="notifications_1_">
        <path
          id="Path_27"
          data-name="Path 27"
          d="M9.352,22a2.209,2.209,0,0,0,2.2-2.2h-4.4A2.206,2.206,0,0,0,9.352,22ZM16.5,15.4V9.352A7.07,7.07,0,0,0,11,2.424V1.652a1.65,1.65,0,1,0-3.3,0V2.42A7.08,7.08,0,0,0,2.2,9.352V15.4L0,17.6v1.1H18.7V17.6Z"
        />
      </g>
    </g>
  </svg>
);

export const Ticket = (
  <svg id="icn-topbar-tickets" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <rect id="Rectangle_9405" data-name="Rectangle 9405" width="32" height="32" fill="#80fc04" opacity="0" />
    <g id="Symbol_3_3" data-name="Symbol 3 – 3" transform="translate(3.699 3.48)" clipPath="url(#clipPath-ticket)">
      <g id="Group_5" data-name="Group 5">
        <path
          id="Path_28"
          data-name="Path 28"
          d="M24.078,8.167,22.235,6.341a2.817,2.817,0,0,1-3.971,0,2.7,2.7,0,0,1-.819-1.986,2.692,2.692,0,0,1,.819-1.986L16.437.542A1.808,1.808,0,0,0,15.117,0,1.78,1.78,0,0,0,13.8.542L.542,13.781A1.808,1.808,0,0,0,0,15.1a1.78,1.78,0,0,0,.542,1.32l1.827,1.842a2.7,2.7,0,0,1,1.986-.819,2.692,2.692,0,0,1,1.986.819,2.817,2.817,0,0,1,0,3.971l1.842,1.842a1.808,1.808,0,0,0,1.32.542,1.78,1.78,0,0,0,1.32-.542L24.078,10.813a1.884,1.884,0,0,0,0-2.646Z"
          transform="translate(0 0)"
        />
      </g>
    </g>
  </svg>
);

export const Inbox = (
  <svg id="icn-topbar-inbox" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <rect id="Rectangle_9406" data-name="Rectangle 9406" width="32" height="32" fill="#80fc04" opacity="0" />
    <g id="Symbol_4_3" data-name="Symbol 4 – 3" transform="translate(4.199 6)" clipPath="url(#clipPath-inbox)">
      <path
        id="Path_29"
        data-name="Path 29"
        d="M23.611,9.545,19.89.919A1.39,1.39,0,0,0,19.32.263,1.513,1.513,0,0,0,18.5,0H5.5A1.5,1.5,0,0,0,4.68.268,1.39,1.39,0,0,0,4.11.925L.389,9.551A5.082,5.082,0,0,0,0,11.472V19a.96.96,0,0,0,.3.7A.964.964,0,0,0,1,20H23a1.009,1.009,0,0,0,1-1V11.472A5.026,5.026,0,0,0,23.611,9.545ZM15.987,11,14.5,14h-5L8.018,11H3.076a.723.723,0,0,0,.038-.126.93.93,0,0,1,.038-.126L6.464,3H17.525l3.311,7.75c.011.033.022.071.038.126s.027.093.038.126Z"
      />
    </g>
  </svg>
);

export const ShoppingCart = (
  <svg id="icn-topbar-cart" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <rect id="Rectangle_9407" data-name="Rectangle 9407" width="32" height="32" fill="#80fc04" opacity="0" />
    <g id="Symbol_5_3" data-name="Symbol 5 – 3" transform="translate(4.699 5.301)" clipPath="url(#clipPath-shopping-cart)">
      <g id="shopping-cart_1_">
        <path
          id="Path_26"
          data-name="Path 26"
          d="M6.51,17.36a2.17,2.17,0,1,0,2.17,2.17A2.176,2.176,0,0,0,6.51,17.36ZM0,0V2.17H2.17l3.906,8.246-1.519,2.6a3.782,3.782,0,0,0-.217,1.085,2.176,2.176,0,0,0,2.17,2.17H19.53v-2.17H6.944a.23.23,0,0,1-.217-.217v-.111L7.7,11.931H15.73a1.984,1.984,0,0,0,1.847-1.085L21.483,3.8a.6.6,0,0,0,.217-.545,1.025,1.025,0,0,0-1.085-1.085H4.557L3.583,0ZM17.36,17.36a2.17,2.17,0,1,0,2.17,2.17A2.179,2.179,0,0,0,17.36,17.36Z"
        />
      </g>
    </g>
  </svg>
);

// Menu
export const DashBoard = (
  <svg id="icn-dashboard" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <rect id="Rectangle_9438" data-name="Rectangle 9438" width="24" height="24" fill="#80fc04" opacity="0" />
    <g id="Group_126" data-name="Group 126" transform="translate(3.5 5.688)">
      <g id="Group_26" data-name="Group 26" transform="translate(0 0.014)">
        <path
          id="Path_35"
          data-name="Path 35"
          d="M11.471.465A8.676,8.676,0,0,0,0,8.721a13.433,13.433,0,0,0,.346,3.13.372.372,0,0,0,.346.346H16.6a.58.58,0,0,0,.435-.346,20.329,20.329,0,0,0,.346-3.13A8.61,8.61,0,0,0,11.471.465Zm-2.78,1.3a.82.82,0,0,1,.869.869.82.82,0,0,1-.869.869.82.82,0,0,1-.869-.869A.82.82,0,0,1,8.691,1.769ZM2.607,9.59a.82.82,0,0,1-.869-.869.82.82,0,0,1,.869-.869.82.82,0,0,1,.869.869A.82.82,0,0,1,2.607,9.59ZM5.041,5.072a.841.841,0,0,1-1.215,0,1.056,1.056,0,0,1-.088-1.3.841.841,0,0,1,1.215,0A1.052,1.052,0,0,1,5.041,5.072ZM8.691,10.46c-.957,0-1.826-.869-1.565-1.738S8.691,5.245,8.691,5.245s1.3,2.607,1.565,3.476S9.648,10.46,8.691,10.46Zm4.953-5.387a.859.859,0,0,1-1.215-1.215.841.841,0,0,1,1.215,0A1.037,1.037,0,0,1,13.644,5.072Zm1.13,4.518a.82.82,0,0,1-.869-.869.869.869,0,1,1,1.738,0A.821.821,0,0,1,14.774,9.59Z"
          transform="translate(0 -0.014)"
          fill="#acacac"
        />
      </g>
    </g>
  </svg>
);

export const Rocket = (
  <svg id="icn-gamehosting" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <rect id="Rectangle_9442" data-name="Rectangle 9442" width="24" height="24" fill="#80fc04" opacity="0" />
    <g id="Group_129" data-name="Group 129" transform="translate(4.523 4.867)">
      <path
        id="Path_41"
        data-name="Path 41"
        d="M14.528.085A.3.3,0,0,0,14.311,0a10.114,10.114,0,0,0-3.866.637A10.453,10.453,0,0,0,7.237,2.949c-.477.484-1,1.068-1.576,1.749l-3.4.179a.328.328,0,0,0-.232.144L.021,8.463a.271.271,0,0,0,.044.349l.575.575a.282.282,0,0,0,.207.082.276.276,0,0,0,.082-.009L3.4,8.7l2.518,2.518-.763,2.478a.285.285,0,0,0,.072.286l.575.575a.327.327,0,0,0,.207.082.316.316,0,0,0,.144-.035L9.6,12.589a.328.328,0,0,0,.144-.232l.179-3.4c.681-.575,1.265-1.1,1.749-1.579a10.3,10.3,0,0,0,2.273-3.231A10.139,10.139,0,0,0,14.616.286.269.269,0,0,0,14.528.085Zm-2.17,3.394a.86.86,0,0,1-1.47-.609.86.86,0,1,1,1.47.609Z"
        transform="translate(0)"
        fill="#acacac"
      />
    </g>
  </svg>
);

export const FlexibleServers = (
  <svg id="icn-dedicated" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <rect id="Rectangle_9446" data-name="Rectangle 9446" width="24" height="24" fill="#80fc04" opacity="0" />
    <g id="Group_134" data-name="Group 134" transform="translate(5.025 4.688)">
      <path
        id="Path_59"
        data-name="Path 59"
        d="M.138,3.718,6.88,6.965a.28.28,0,0,0,.248,0L13.87,3.718a.286.286,0,0,0,0-.516L7.128-.046a.28.28,0,0,0-.248,0L.138,3.2A.286.286,0,0,0,.138,3.718Z"
        transform="translate(0 0)"
        fill="#acacac"
      />
      <path
        id="Path_60"
        data-name="Path 60"
        d="M.138,154l6.742,3.247a.28.28,0,0,0,.248,0L13.87,154a.286.286,0,0,0,0-.516l-1.421-.683L7.93,154.981A2.161,2.161,0,0,1,7,155.19a2.1,2.1,0,0,1-.926-.213L1.559,152.8l-1.421.691A.282.282,0,0,0,.138,154Z"
        transform="translate(0 -146.351)"
        fill="#acacac"
      />
      <path
        id="Path_61"
        data-name="Path 61"
        d="M13.87,245.787l-1.421-.683L7.93,247.281A2.162,2.162,0,0,1,7,247.49a2.1,2.1,0,0,1-.926-.213L1.559,245.1l-1.421.683a.286.286,0,0,0,0,.516l6.742,3.247a.28.28,0,0,0,.247,0L13.87,246.3A.282.282,0,0,0,13.87,245.787Z"
        transform="translate(0 -234.713)"
        fill="#acacac"
      />
    </g>
  </svg>
);

export const Grid = (
  <svg id="icn-colocation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <rect id="Rectangle_9444" data-name="Rectangle 9444" width="24" height="24" fill="#80fc04" opacity="0" />
    <g id="Group_7311" data-name="Group 7311" transform="translate(4.5 4.5)">
      <rect id="Rectangle_7136" data-name="Rectangle 7136" width="3.654" height="3.654" transform="translate(5.481 5.481)" fill="#acacac" />
      <rect id="Rectangle_7137" data-name="Rectangle 7137" width="3.654" height="3.654" transform="translate(0 0)" fill="#acacac" />
      <rect id="Rectangle_7138" data-name="Rectangle 7138" width="3.654" height="3.654" transform="translate(5.481 10.961)" fill="#acacac" />
      <rect id="Rectangle_7139" data-name="Rectangle 7139" width="3.654" height="3.654" transform="translate(0 5.481)" fill="#acacac" />
      <rect id="Rectangle_7140" data-name="Rectangle 7140" width="3.654" height="3.654" transform="translate(0 10.961)" fill="#acacac" />
      <rect id="Rectangle_7141" data-name="Rectangle 7141" width="3.654" height="3.654" transform="translate(10.961 0)" fill="#acacac" />
      <rect id="Rectangle_7142" data-name="Rectangle 7142" width="3.654" height="3.654" transform="translate(5.481 0)" fill="#acacac" />
      <rect id="Rectangle_7143" data-name="Rectangle 7143" width="3.654" height="3.654" transform="translate(10.961 5.481)" fill="#acacac" />
      <rect id="Rectangle_7144" data-name="Rectangle 7144" width="3.654" height="3.654" transform="translate(10.961 10.961)" fill="#acacac" />
    </g>
  </svg>
);

export const CloudNoBackground = (
  <svg id="icn-cloud" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <rect id="Rectangle_9453" data-name="Rectangle 9453" width="24" height="24" fill="#80fc04" opacity="0" />
    <path
      id="Path_13874"
      data-name="Path 13874"
      d="M16.451,92.578a3.847,3.847,0,0,0-.763.076,3.146,3.146,0,0,0-4.406-2.237,4.2,4.2,0,0,0-7.894,2.866,3.5,3.5,0,0,0,.105,7H16.451a3.852,3.852,0,1,0,0-7.7Z"
      transform="translate(1.637 -81.738)"
      fill="#acacac"
    />
  </svg>
);

export const Expand = (
  <svg id="icn-cdn" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <rect id="Rectangle_9444" data-name="Rectangle 9444" width="24" height="24" fill="#80fc04" opacity="0" />
    <g id="Group_7310" data-name="Group 7310" transform="translate(-69.094 -69.111)">
      <g id="Group_4252" data-name="Group 4252" transform="translate(73.594 73.609)">
        <path
          id="Path_13970"
          data-name="Path 13970"
          d="M88.209,73.609H82.146L84.133,75.6l-3.23,3.23L77.672,75.6l1.987-1.987H73.595v6.065l1.989-1.989,3.231,3.231-3.231,3.231L73.6,82.16v6.063H79.66L77.67,86.234,80.9,83l3.233,3.233-1.989,1.989,6.064,0V82.162l-1.987,1.987L82.99,80.915l3.23-3.23,1.989,1.989Z"
          transform="translate(-73.594 -73.609)"
          fill="#acacac"
        />
      </g>
    </g>
  </svg>
);

export const Backup = (
  <svg id="icn-backup" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <rect id="Rectangle_13992" data-name="Rectangle 13992" width="24" height="24" fill="#80fc04" opacity="0" />
    <g id="backup" transform="translate(111.969 -2.633)">
      <g id="Group_9374" data-name="Group 9374" transform="translate(-109.884 4.615)">
        <g id="Group_9373" data-name="Group 9373" transform="translate(0 0)">
          <path
            id="Path_29512"
            data-name="Path 29512"
            d="M282.365,249.6h0a1.413,1.413,0,0,1-1.414-1.414,9.9,9.9,0,0,1,18.107-5.535,1.413,1.413,0,1,1-2.342,1.583,7.046,7.046,0,0,0-10.986-.9l1.51.755a1.414,1.414,0,0,1,.152,2.442l-4.243,2.828c-.026.017-.057.01-.083.025a1.377,1.377,0,0,1-.7.211Zm8.484,8.485a9.891,9.891,0,0,1-8.208-4.364,1.413,1.413,0,1,1,2.342-1.583,7.046,7.046,0,0,0,10.986.9l-1.51-.755a1.414,1.414,0,0,1-.152-2.442l4.243-2.828c.033-.022.044,0,.073-.018a1.376,1.376,0,0,1,.711-.219,1.414,1.414,0,0,1,1.414,1.414A9.912,9.912,0,0,1,290.849,258.082Z"
            transform="translate(-280.95 -238.283)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const Support = (
  <svg id="icn-support" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <rect id="Rectangle_9450" data-name="Rectangle 9450" width="24" height="24" fill="#80fc04" opacity="0" />
    <g id="Group_135" data-name="Group 135" transform="translate(3.67 5.414)">
      <g id="Group_47" data-name="Group 47" transform="translate(0)">
        <path
          id="Path_55"
          data-name="Path 55"
          d="M10.155,9.176a6.108,6.108,0,0,0,2.462-1.789,3.832,3.832,0,0,0,0-4.938A6.077,6.077,0,0,0,10.155.659,8.6,8.6,0,0,0,6.761,0,8.6,8.6,0,0,0,3.367.659,6.108,6.108,0,0,0,.9,2.449,3.862,3.862,0,0,0,0,4.918,3.787,3.787,0,0,0,.683,7.07a5.6,5.6,0,0,0,1.874,1.7c-.064.155-.131.3-.2.424a2.564,2.564,0,0,1-.239.37c-.094.118-.165.212-.215.279a3.717,3.717,0,0,1-.249.283c-.114.121-.188.2-.222.239,0-.007-.013.007-.037.044s-.04.05-.044.047-.017.013-.037.047a.481.481,0,0,0-.034.054l-.024.047a.194.194,0,0,0-.02.057.386.386,0,0,0,0,.064.2.2,0,0,0,.01.064.318.318,0,0,0,.111.2.308.308,0,0,0,.2.077h.03a8.022,8.022,0,0,0,.827-.155A8.106,8.106,0,0,0,5.082,9.684a9.792,9.792,0,0,0,1.689.155A8.709,8.709,0,0,0,10.155,9.176Z"
          transform="translate(0)"
          fill="#acacac"
        />
        <path
          id="Path_56"
          data-name="Path 56"
          d="M186.705,108.875a3.749,3.749,0,0,0-.037-4.366,5.69,5.69,0,0,0-1.958-1.709,4.935,4.935,0,0,1-.42,3.9,6.447,6.447,0,0,1-1.843,2.035,8.439,8.439,0,0,1-2.536,1.238,10.111,10.111,0,0,1-2.967.431c-.192,0-.474-.013-.844-.037a8.082,8.082,0,0,0,4.534,1.268,9.506,9.506,0,0,0,1.692-.155A8.039,8.039,0,0,0,185,112.706c.232.057.5.108.827.155a.292.292,0,0,0,.212-.067.357.357,0,0,0,.124-.212c0-.037,0-.061.01-.064s.007-.024,0-.064-.02-.057-.02-.057l-.024-.047a.406.406,0,0,0-.034-.054c-.017-.024-.03-.037-.037-.047s-.024-.027-.044-.047a.511.511,0,0,1-.037-.044c-.034-.037-.1-.118-.222-.239a3.711,3.711,0,0,1-.249-.283c-.05-.067-.124-.161-.215-.279a2.309,2.309,0,0,1-.239-.37c-.067-.128-.131-.269-.2-.424A5.676,5.676,0,0,0,186.705,108.875Z"
          transform="translate(-170.177 -99.342)"
          fill="#acacac"
        />
      </g>
    </g>
  </svg>
);

export const Settings = (
  <svg id="icn-settings" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <rect id="Rectangle_9361" data-name="Rectangle 9361" width="24" height="24" fill="#80fc04" opacity="0" />
    <g id="Group_5788" data-name="Group 5788" transform="translate(-452 -1108.999)">
      <g id="Group_1544" data-name="Group 1544" transform="translate(454 1111)">
        <g id="Group_1543" data-name="Group 1543" transform="translate(0 0)" clipPath="url(#clipPath-settings)">
          <path
            id="Path_1989"
            data-name="Path 1989"
            d="M473.867,1119.849a.649.649,0,0,0-.641-.49,2.2,2.2,0,0,1-1.506-3.826.553.553,0,0,0,.061-.751,9.855,9.855,0,0,0-1.579-1.593.555.555,0,0,0-.758.061,2.3,2.3,0,0,1-2.485.558,2.211,2.211,0,0,1-1.346-2.161.553.553,0,0,0-.489-.582,9.95,9.95,0,0,0-2.242-.006.554.554,0,0,0-.493.57,2.216,2.216,0,0,1-1.365,2.124,2.3,2.3,0,0,1-2.467-.561.556.556,0,0,0-.752-.063,9.9,9.9,0,0,0-1.612,1.592.553.553,0,0,0,.059.756,2.2,2.2,0,0,1,.557,2.484,2.3,2.3,0,0,1-2.168,1.346.542.542,0,0,0-.576.489,9.959,9.959,0,0,0,0,2.264.66.66,0,0,0,.654.49,2.185,2.185,0,0,1,2.051,1.364,2.213,2.213,0,0,1-.557,2.462.552.552,0,0,0-.06.75,9.881,9.881,0,0,0,1.576,1.593.554.554,0,0,0,.759-.06,2.3,2.3,0,0,1,2.484-.558,2.208,2.208,0,0,1,1.348,2.161.553.553,0,0,0,.489.582,9.937,9.937,0,0,0,2.242.006.554.554,0,0,0,.493-.57,2.213,2.213,0,0,1,1.364-2.123,2.3,2.3,0,0,1,2.468.561.557.557,0,0,0,.752.063,9.916,9.916,0,0,0,1.612-1.592.553.553,0,0,0-.059-.757,2.2,2.2,0,0,1-.558-2.483,2.231,2.231,0,0,1,2.039-1.35l.123,0a.554.554,0,0,0,.583-.488,9.926,9.926,0,0,0,0-2.264Zm-9.887,4.447a3.321,3.321,0,1,1,3.324-3.321,3.326,3.326,0,0,1-3.324,3.321Zm0,0"
            transform="translate(-453.999 -1110.999)"
            fillRule="evenodd"
          />
        </g>
      </g>
    </g>
  </svg>
);
